module.exports = __webpack_public_path__ + "img/202412_basic_04.926c569a.jpg";